"use client"

import { Menu02, X as CloseIcon } from "@untitledui/icons"
import type { PropsWithChildren } from "react"
import {
  Button as AriaButton,
  Dialog as AriaDialog,
  DialogTrigger as AriaDialogTrigger,
  Modal as AriaModal,
  ModalOverlay as AriaModalOverlay,
} from "react-aria-components"

import { cx } from "@/components/ui/cx"
import { Wordmark } from "@/components/ui/wordmark"

/* Below lg the rail folds into a board-coloured bar; the drawer is the rail itself. */
export const MobileNavigationHeader = ({ children }: PropsWithChildren) => {
  return (
    <AriaDialogTrigger>
      <header className="board flex h-14 items-center justify-between pr-2 pl-4 lg:hidden">
        <Wordmark size={22} className="text-stone-50" />

        <AriaButton
          aria-label="Expand navigation menu"
          className="group text-onprint-emphasis hover:bg-onprint-hover relative flex size-11 items-center justify-center rounded-lg outline-none hover:text-stone-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-50"
        >
          <Menu02 className="size-6 transition duration-200 ease-in-out group-aria-expanded:opacity-0" />
          <CloseIcon className="absolute size-6 opacity-0 transition duration-200 ease-in-out group-aria-expanded:opacity-100" />
        </AriaButton>
      </header>

      <AriaModalOverlay
        isDismissable
        className={({ isEntering, isExiting }) =>
          cx(
            "scrim fixed inset-0 z-50 cursor-pointer pr-16 lg:hidden",
            isEntering && "animate-in fade-in duration-300 ease-in-out",
            isExiting && "animate-out fade-out duration-200 ease-in-out",
          )
        }
      >
        {({ state }) => (
          <>
            <AriaButton
              aria-label="Close navigation menu"
              onPress={() => state.close()}
              className="text-onprint-emphasis hover:bg-onprint-hover fixed top-2 right-2 flex size-11 cursor-pointer items-center justify-center rounded-lg outline-none hover:text-stone-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-50"
            >
              <CloseIcon className="size-6" />
            </AriaButton>

            <AriaModal className="w-full cursor-auto will-change-transform">
              <AriaDialog className="h-dvh outline-hidden focus:outline-hidden">
                {children}
              </AriaDialog>
            </AriaModal>
          </>
        )}
      </AriaModalOverlay>
    </AriaDialogTrigger>
  )
}
